var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_376_3",
    "data-name": "Component 376 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1886",
    "data-name": "Path 1886",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 C 1 11.85980987548828 4.140190124511719 15 8 15 C 11.85980987548828 15 15 11.85980987548828 15 8 C 15 4.140190124511719 11.85980987548828 1 8 1 M 8 0 C 12.41827964782715 0 16 3.581720352172852 16 8 C 16 12.41827964782715 12.41827964782715 16 8 16 C 3.581720352172852 16 0 12.41827964782715 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z",
    stroke: "none",
    fill: "#810155"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16089",
    "data-name": "Path 16089",
    d: "M1.974-8.008c.8,0,1.19-.336,1.19-1.022s-.392-1.036-1.19-1.036S.784-9.716.784-9.03,1.176-8.008,1.974-8.008ZM2.926-7H1.008V0H2.926Z",
    transform: "translate(6 13.066)",
    fill: "#810155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoblue);
export default __webpack_public_path__ + "static/media/infoblue.bfbabac0ac0db2636a02aec770634363.svg";
export { ForwardRef as ReactComponent };